import { Controller } from 'libraries/front-end-core/core/Router'
import Main from './Main'
import Header from './Header'
import getUrl from 'libraries/front-end-core/core/url'
import { LEGISLATION, LEGISLATION_REVIEW, LEGISLATION_FOLDERS } from 'constants/controllers'
import { URL_PDF_LEG } from 'constants/urls'

export default new Controller({
  name: LEGISLATION_REVIEW,
  route: 'legreview/:selectedIds',
  controller (
    Router,
    { url: pageId, scrollMain, query: { short }, params: { selectedIds } },
    render
  ) {
    render(
      { Header, Main },
      {
        selectedIds: selectedIds.split(','),
        short,
        pdfUrl: URL_PDF_LEG,
        returnUrl: getUrl(LEGISLATION_FOLDERS),
        type: 'legislation'
      },
      {
        pageId,
        searchType: 'legislation',
        className: 'legislation content-review',
        bottleLink: flavour => getUrl(LEGISLATION)
      }
    )

    return pageId
  }
})
